import { useAuth0 } from "@auth0/auth0-react";

import API_Calls_Template from "@/api/calls/API_Calls_Template";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

const useTemplateNamesHandler = () => {
  const { fetchTemplates } = API_Calls_Template();
  const { templateNames, handleTemplateNamesChange } = useUpdateDataContext();
  const { user } = useAuth0();

  const updateTemplateNamesList = async () => {
    const response = await fetchTemplates(user.org_name);
    if (response.data) {
      const templateNames = [];
      response.data.forEach((template) => {
        templateNames.push(template.name);
      });
      const nameAndHash = {};
      response.data.forEach((template) => {
        if (hasMultipleOccurrences(templateNames, template.name)) {
          nameAndHash[`${template.name}/${template.created}`] =
            templateDateHashifier(template.created);
        } else {
          nameAndHash[`${template.name}/${template.created}`] = null;
        }
      });
      // { "foo/20140101": "abc", "bar/20240101": null, "foo/20240102": "cde" }
      handleTemplateNamesChange(nameAndHash);
    }
  };

  const templateDateHashifier = (s) => {
    let h = 0xdeadbeef;
    for (const c of s) h = Math.imul(h ^ c, 2654435761);
    const r = (h ^ (h >>> 16)) >>> 0;
    return btoa(r).slice(2, 5);
  };

  const getDisplayName = (name, timestamp) => {
    // if context is null, updateTemplateNamesList
    if (!templateNames) {
      updateTemplateNamesList();
      return name;
    }
    const hash = templateNames[`${name}/${timestamp}`];
    const displayName = hash ? `${name} v.${hash}` : name;
    return displayName;
  };

  const hasMultipleOccurrences = (arr, str) => {
    return arr.filter((item) => item === str).length >= 2;
  };

  return { updateTemplateNamesList, getDisplayName };
};

export default useTemplateNamesHandler;
